import clsx from 'clsx';

export interface IconArrowProps {
  type?: 'up' | 'down';
  className?: string;
  disabled?: boolean;
}

const IconArrow = ({
  type = 'down',
  className,
  disabled = false,
}: IconArrowProps) => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      'transition-all duration-300 motion-reduce:transition-none',
      type === 'up' && 'rotate-180',
      !disabled &&
        'group-hover/button:fill-brand-primary-100 group-focus/button:fill-brand-primary-100 group-active/button:fill-brand-primary-100',
      className,
    )}
  >
    <path d="M4.99967 6.45799C4.88834 6.45799 4.78067 6.43732 4.67667 6.39599C4.57267 6.35399 4.47201 6.28466 4.37467 6.18799L0.603674 2.41699C0.437008 2.25032 0.360674 2.04199 0.374674 1.79199C0.388674 1.54199 0.472007 1.34066 0.624674 1.18799C0.805341 1.00733 1.01367 0.920325 1.24967 0.926992C1.48567 0.934325 1.68701 1.02133 1.85367 1.18799L4.99967 4.35399L8.16667 1.18799C8.33334 1.02133 8.53101 0.937992 8.75967 0.937992C8.98901 0.937992 9.19401 1.02799 9.37467 1.20799C9.54134 1.37466 9.62467 1.57966 9.62467 1.82299C9.62467 2.06632 9.54134 2.27132 9.37467 2.43799L5.62467 6.18799C5.52734 6.28466 5.42667 6.35399 5.32267 6.39599C5.21867 6.43732 5.11101 6.45799 4.99967 6.45799Z" />
  </svg>
);

export default IconArrow;
